//projects
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const UPDATE_TEAM_PROJECTS = 'UPDATE_TEAM_PROJECTS';
export const CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR';
export const CREATE_PROJECT_LOADING = 'CREATE_PROJECT_LOADING';
export const GET_PROJECTS_BY_SEED = 'GET_PROJECTS_BY_SEED';
export const GET_PROJECTS_BY_SEED_ERROR = 'GET_PROJECTS_BY_SEED_ERROR';
export const GET_PROJECTS_BY_SEED_LOADING = 'GET_PROJECTS_BY_SEED_LOADING';
export const GET_PROJECTS_BY_SEED_AND_TEAM = 'GET_PROJECTS_BY_SEED_AND_TEAM';
export const GET_PROJECTS_BY_SEED_AND_TEAM_ERROR =
  'GET_PROJECTS_BY_SEED_AND_TEAM_ERROR';
export const GET_PROJECTS_BY_SEED_AND_TEAM_LOADING =
  'GET_PROJECTS_BY_SEED_AND_TEAM_LOADING';

// Edit a project
export const PATCH_PROJECT = 'PATCH_PROJECT';
export const PATCH_PROJECT_SUCCESS = 'PATCH_PROJECT_SUCCESS';
export const PATCH_PROJECT_ERROR = 'PATCH_PROJECT_ERROR';
export const PATCH_PROJECT_LOADING = 'PATCH_PROJECT_LOADING';

// project updates
export const CREATE_PROJECT_UPDATE = 'CREATE_PROJECT_UPDATE';
export const CREATE_PROJECT_UPDATE_ERROR = 'CREATE_PROJECT_UPDATE_ERROR';
export const CREATE_PROJECT_UPDATE_LOADING = 'CREATE_PROJECT_UPDATE_LOADING';
export const UPDATE_PROJECT_UPDATES = 'UPDATE_PROJECT_UPDATES';
export const UPDATE_PROJECT_UPDATES_ERROR = 'UPDATE_PROJECT_UPDATES_ERROR';
export const UPDATE_PROJECT_UPDATES_LOADING = 'UPDATE_PROJECT_UPDATES_LOADING';

//columns
export const GET_COLUMNS = 'GET_COLUMNS';
export const GET_COLUMNS_ERROR = 'GET_COLUMNS_ERROR';
export const GET_COLUMNS_LOADING = 'GET_COLUMNS_LOADING';
export const CREATE_COLUMN = 'CREATE_COLUMN';
export const CREATE_COLUMN_ERROR = 'CREATE_COLUMN_ERROR';
export const CREATE_COLUMN_LOADING = 'CREATE_COLUMN_LOADING';
export const DELETE_COLUMN = 'DELETE_COLUMN';
export const DELETE_COLUMN_ERROR = 'DELETE_COLUMN_ERROR';
export const DELETE_COLUMN_LOADING = 'DELETE_COLUMN_LOADING';

//tasks
export const CREATE_TASK = 'CREATE_TASK';
export const CREATE_TASK_ERROR = 'CREATE_TASK_ERROR';
export const CREATE_TASK_LOADING = 'CREATE_TASK_LOADING';
export const GET_TASKS = 'GET_TASKS';
export const GET_TASKS_ERROR = 'GET_TASKS_ERROR';
export const GET_TASKS_LOADING = 'GET_TASKS_LOADING';
export const DELETE_TASK = 'DELETE_TASK';
export const DELETE_TASK_ERROR = 'DELETE_TASK_ERROR';
export const DELETE_TASK_LOADING = 'DELETE_TASK_LOADING';
export const UPDATE_TASK = 'UPDATE_TASK';
export const UPDATE_TASK_ERROR = 'UPDATE_TASK_ERROR';
export const UPDATE_TASK_LOADING = 'UPDATE_TASK_LOADING';

//task comments
export const GET_TASK_COMMENTS = 'GET_TASK_COMMENTS';
export const GET_TASK_COMMENTS_ERROR = 'GET_TASK_COMMENTS_ERROR';
export const GET_TASK_COMMENTS_LOADING = 'GET_TASK_COMMENTS_LOADING';
export const CREATE_TASK_COMMENT = 'CREATE_TASK_COMMENT';
export const CREATE_TASK_COMMENT_ERROR = 'CREATE_TASK_COMMENT_ERROR';
export const CREATE_TASK_COMMENT_LOADING = 'CREATE_TASK_COMMENT_LOADING';

// Assign user to task
export const ASSIGN_USER_TO_TASK_LOADING = 'ASSIGN_USER_TO_TASK_LOADING';
export const ASSIGN_USER_TO_TASK_SUCCESS = 'ASSIGN_USER_TO_TASK_SUCCESS';
export const ASSIGN_USER_TO_TASK_ERROR = 'ASSIGN_USER_TO_TASK_ERROR';
